'use strict';

var dateFns = require('date-fns');
var constants = require('./constants.cjs');
var transformDateTimePartNumberToStringWithZeroPadding = require('./utils/common/transformDateTimePartNumberToStringWithZeroPadding.cjs');
var disassembleISODatePartWithoutYearToParts = require('./utils/disassembleToParts/disassembleISODatePartWithoutYearToParts.cjs');
var disassembleISODatePartWithoutDayToParts = require('./utils/disassembleToParts/disassembleISODatePartWithoutDayToParts.cjs');
var disassembleISOTimePartToParts = require('./utils/disassembleToParts/disassembleISOTimePartToParts.cjs');
var assemblePartsToISODatePartWithoutDay = require('./utils/assembleParts/assemblePartsToISODatePartWithoutDay.cjs');

const combineISOParts = ({
  isoDatePart,
  isoTimePart
}) => `${isoDatePart}T${isoTimePart}`;
const isoFullPartToDate = (isoFullPart) => dateFns.parseISO(isoFullPart);
const isoDateTimePartToDate = (isoDateTimePart) => dateFns.parseISO(isoDateTimePart);
const isoDateTimePartToDatePart = (isoDateTimePart) => isoDateTimePart.split("T")[0];
const isoDateTimePartToTimePart = (isoDateTimePart) => isoDateTimePart.split("T")[1];
const isoDatePartToDate = (isoDatePart) => dateFns.parseISO(isoDatePart);
const isoDatePartWithoutYearToDate = (isoDatePartWithoutYear) => {
  const { month, day } = disassembleISODatePartWithoutYearToParts(
    isoDatePartWithoutYear
  );
  return dateFns.setMonth(dateFns.setDate(0, day), month - 1);
};
const isoDatePartWithoutDayToDate = (isoDatePartWithoutDay) => {
  const { year, month } = disassembleISODatePartWithoutDayToParts(
    isoDatePartWithoutDay
  );
  return dateFns.parseISO(
    `${transformDateTimePartNumberToStringWithZeroPadding(
      year,
      4
    )}-${transformDateTimePartNumberToStringWithZeroPadding(month)}-01`
  );
};
const dayOfWeekToDate = (dayOfWeek) => dateFns.setDay(0, dayOfWeek);
const datePartsWithoutDayToDate = (datePartsWithoutDay) => isoDatePartWithoutDayToDate(
  assemblePartsToISODatePartWithoutDay(datePartsWithoutDay)
);
const isoTimePartToDate = (isoTimePart) => {
  const { hour, minute, second } = disassembleISOTimePartToParts(isoTimePart);
  return dateFns.setHours(dateFns.setMinutes(dateFns.setSeconds(0, second), minute), hour);
};
const dateToISODateTimePart = (date) => dateFns.format(date, constants.ISO_DATE_TIME_PART_FORMAT);
const dateToISODatePart = (date) => dateFns.format(date, constants.ISO_DATE_PART_FORMAT);
const dateToISOFullPart = (date) => dateFns.format(date, constants.ISO_FULL_FORMAT);
const dateToDayOfWeek = (date) => dateFns.getDay(date);
const dateToDatePartsWithoutDay = (date) => disassembleISODatePartWithoutDayToParts(dateToISODatePartWithoutDay(date));
const dateToISOTimePart = (date) => dateFns.format(date, constants.ISO_TIME_PART_FORMAT);
const dateToISODatePartWithoutDay = (date) => dateFns.format(date, constants.ISO_DATE_PART_WITHOUT_DAY_FORMAT);
const isoDatePartToDayOfWeek = (isoDatePart) => dateToDayOfWeek(isoDatePartToDate(isoDatePart));
const dateToMinutes = (date) => dateFns.hoursToMinutes(dateFns.getHours(date)) + dateFns.getMinutes(date);

exports.combineISOParts = combineISOParts;
exports.datePartsWithoutDayToDate = datePartsWithoutDayToDate;
exports.dateToDatePartsWithoutDay = dateToDatePartsWithoutDay;
exports.dateToDayOfWeek = dateToDayOfWeek;
exports.dateToISODatePart = dateToISODatePart;
exports.dateToISODatePartWithoutDay = dateToISODatePartWithoutDay;
exports.dateToISODateTimePart = dateToISODateTimePart;
exports.dateToISOFullPart = dateToISOFullPart;
exports.dateToISOTimePart = dateToISOTimePart;
exports.dateToMinutes = dateToMinutes;
exports.dayOfWeekToDate = dayOfWeekToDate;
exports.isoDatePartToDate = isoDatePartToDate;
exports.isoDatePartToDayOfWeek = isoDatePartToDayOfWeek;
exports.isoDatePartWithoutDayToDate = isoDatePartWithoutDayToDate;
exports.isoDatePartWithoutYearToDate = isoDatePartWithoutYearToDate;
exports.isoDateTimePartToDate = isoDateTimePartToDate;
exports.isoDateTimePartToDatePart = isoDateTimePartToDatePart;
exports.isoDateTimePartToTimePart = isoDateTimePartToTimePart;
exports.isoFullPartToDate = isoFullPartToDate;
exports.isoTimePartToDate = isoTimePartToDate;
//# sourceMappingURL=parsers.cjs.map
